/* unplugin-vue-components disabled */import { render } from "./mycontract.vue?vue&type=template&id=4aba8691&scoped=true"
import script from "./mycontract.vue?vue&type=script&lang=js"
export * from "./mycontract.vue?vue&type=script&lang=js"

import "./mycontract.vue?vue&type=style&index=0&id=4aba8691&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aba8691"]])

export default __exports__